import { inputAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/react";

const { definePartsStyle, defineMultiStyleConfig } =
	createMultiStyleConfigHelpers(inputAnatomy.keys);

const primary500 = "primary.500";

const outline = definePartsStyle({
	field: {
		textColor: "primary.1000",
		caretColor: (theme) => theme.colors.primary[500] as string,
		_focus: {
			borderColor: primary500,
		},
		_focusVisible: {
			boxShadow: "0 0 0 1px #799351",
		},
	},
});

const filled = definePartsStyle({
	field: {
		textColor: "primary.1000",
		bgColor: "white",
		caretColor: (theme) => theme.colors.primary[1000] as string,
		borderColor: primary500,
		borderWidth: "1px",
		_invalid: {
			borderColor: "secondary-accent.500",
			_focus: {
				borderColor: "secondary-accent.500",
			},
			_focusVisible: {
				boxShadow: (theme) =>
					`0 0 0 1px ${theme.colors["secondary-accent"][500]}`,
			},
		},
		_placeholder: {
			textColor: "primary.200",
		},
		_hover: {
			bgColor: "white",
		},
		_active: {
			bgColor: "white",
		},
		_focus: {
			borderColor: primary500,
			borderWidth: "1px",
			bgColor: "white",
		},
		_focusVisible: {
			boxShadow: "0 0 0 1px #799351",
			bgColor: "white",
		},
	},
});

export const Input = defineMultiStyleConfig({
	variants: { outline, filled },
	defaultProps: {
		size: "lg",
	},
});
